(function ($) {
	'use strict';
	$(document).ready(function () {

		// Set ticket status
		$('.js-gf-entry-tickets-verify-ticket').submit(function (event) {
			event.preventDefault()

			const form_data = $(this).serializeArray()

			let form_data_obj = {}
			$(form_data).each(function (index, obj) {
				form_data_obj[obj.name] = obj.value
			});

			$.post({
				url: gf_entry_tickets_ajax_obj.ajax_url,
				data: {
					action: 'gf_entry_tickets_save_consent',
					nonce: gf_entry_tickets_ajax_obj.nonce,
					data: form_data_obj
				},
				success: function (response) {
					if (response.success === false) {
						alert(response.data.message)
						return
					}

					$('.gf-entry-tickets-verify-form').hide()
					$('.gform_not_found').hide()
					$('.gf-entry-tickets-container').html(
						'<div class="gf-entry-tickets-feedback">' +
						'<h2>' + response.data.message + '</h2>' +
						'<br/>' + 
						'<p>' + response.data.description + '</p>' +
						'</div>'
					)
				},
				error: function (response) {
					console.error(response)
					alert('An error occurred. Please reload the page and try again.')
				}
			})
		})

	});
})(jQuery);
